import { EuiSpacer } from '@elastic/eui';
import InstarVisionCard from 'components/Software/Windows/InstarVision/Webserver/instarVisionCard01';
import InstarVisionCards from 'components/Software/Windows/InstarVision/Webserver/instarVisionCards01';
import PrimaryBox from 'components/Software/Windows/InstarVision/Webserver/PrimaryBox';
import UserTable from 'components/Software/Windows/InstarVision/Webserver/userTable';
import NavButtons from 'components/Software/Windows/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  InstarVisionCard,
  InstarVisionCards,
  PrimaryBox,
  UserTable,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};